import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from './sub_components/toast';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as currentBetsService from '../services/currentBetsService'
import Currency from './sub_components/currency'
import socketIOClient from "socket.io-client";
import { SOCKET_ROOT as liveSocketEndPoint } from '../configs/api'
import * as dateUtil from '../util/date.util';
import * as userUtil from '../util/user.util';
import moment from 'moment';

let accessToken = !!localStorage.getItem("userAuthDetail") ? JSON.parse(localStorage.getItem("userAuthDetail")).token : "";
let socket = null;

class LiveBets extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            user_id: "",
            accounts: '',
            sportType: "ALL",
            marketType: "",
            marketName: "",
            eventName: "",
            evts_name: [],
            mkts_name: [],
            bets_data: [],
            bets_search_data: [],
            deactivatMarkets: [],
            deactivatOrders: [],
            amount_from: "",
            amount_to: "",
            toastMsg: "",
            toastType: "",
            showData: false,
            loader: false,
            isStop: false,
            event_dictionary: {}
        };
    }

    async componentDidMount() {
        let self = this;

        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if(!(!!userData && !!userData.sub)){
            localStorage.clear();
            this.props.history.push("/auth")
        }
        this.setState({ accounts: userData.sub })

        this.submitForm()

        if (accessToken !== "") {
            socket = socketIOClient(liveSocketEndPoint, {
                query: 'token=' + accessToken
                , transports: ["websocket"]
            });
        }

        socket.emit('user_room', userData.sub);
        socket.emit('site_room', userData.sub);

        socket.on("site_room", data => {
            let msg = JSON.parse(data);
            self.onMessage(msg);
        })

        socket.on('disconnect', () => {
            socket.emit('user_room', userData.sub);
            socket.emit('site_room', userData.sub);
        })
    }

    componentWillUnmount() {
        socket.off()
    }

    onMessage(msg) {
        let self = this;
        // console.log(msg)
        if (!this.state.isStop) {
            if (!!msg.command && (msg.command === "SPORTSBETPLACED" || msg.command === "BINARYBETPLACED")) {

                let bets_data = this.state.bets_data
                msg.payload.side = msg.payload.side === "BACK" ? 0 : 1
                let eventDetail = this.state.event_dictionary[msg.payload.eventId]
                msg.payload.eventName = eventDetail.name
                msg.payload.eventTypeId = eventDetail.eventTypeId
                msg.payload.eventTypeName = eventDetail.eventType
                msg.payload.competitionId = eventDetail.competitionId
                msg.payload.competitionName = eventDetail.compititionName
                // msg.payload.createdAt = new Date();
                let newData = [msg.payload]
                newData = newData.concat(bets_data)
                newData = newData.splice(0, 100)

                this.setState({ bets_data: newData })
            }
            if (!!msg.command && (msg.command === "RESULTDECLARED" || msg.command === "BINARYRESULTDECLARED")) {
                self.resultDeclered("market", msg.payload)
                if (msg.payload.pnl > 0) {
                    self.props.notify("Congratulations! You WON " + msg.payload.pnl + " from your bets on " + msg.payload.marketName + ". 🤑", "success")
                } else if (msg.payload.pnl < 0) {
                    self.props.notify("Oops! You lost " + msg.payload.pnl + " from your bets on " + msg.payload.marketName + ". 😢", "error")
                }
            }
            if (!!msg.command && (msg.command === "VOIDORDER" || msg.command === "BINARYVOIDORDER")) {
                self.resultDeclered("order", msg.payload)
                if (msg.payload.pnl > 0) {
                    self.props.notify("Your account has been credited with " + msg.payload.pnl + " because of rollback in " + msg.payload.marketName + ".", "success")
                } else if (msg.payload.pnl < 0) {
                    self.props.notify("Your account has been debited with " + msg.payload.pnl + " due to rollback in " + msg.payload.marketName + ".", "error")
                }
            }
            if (!!msg.command && (msg.command === "RESULTROLLBACK" || msg.command === "BINARYRESULTROLLBACK")) {
                self.resultDeclered("rollback", msg.payload)
            }
            if (!!msg.command && msg.command === "Orders.NotifyVoidSportsMarket") {
                self.resultDeclered("market", msg.payload)
            }
            if (!!msg.command && (msg.command === "SPORTSMARKETVOID" || msg.command === "BINARYMARKETVOID")) {
                self.resultDeclered("marketvoid", msg.payload)
                self.props.notify(" Market " + msg.payload.marketName + " is Voided !", "error")
            }
        }
    }

    async resultDeclered(type, payload) {
        let deactivatMarkets = this.state.deactivatMarkets
        let deactivatOrders = this.state.deactivatOrders
        if (type === "market") {
            if (!!payload && !!payload.marketId) {
                deactivatMarkets.push(payload.marketId)
            }
        } else if (type === "order") {
            if (!!payload && !!payload.orderId) {
                deactivatOrders.push(payload.orderId)
            }
        } else if (type === "rollback") {
            if (!!payload && !!payload.marketId) {
                let index = deactivatMarkets.indexOf(payload.marketId)
                if (index > -1) {
                    deactivatMarkets.splice(index, 1)
                }
                this.onSubmitForm()
            }
        } else if (type === "marketvoid") {
            if (!!payload && !!payload.marketId) {
                deactivatMarkets.push(payload.marketId)
            }
        }
        this.setState({ deactivatMarkets: deactivatMarkets, deactivatOrders: deactivatOrders })
    }

    parseFilterBody() {

        let amount_from, amount_to;
        if (parseFloat(this.state.amount_from) < parseFloat(this.state.amount_to)) {
            amount_from = parseFloat(this.state.amount_from)
            amount_to = parseFloat(this.state.amount_to)
        }
        else {
            amount_from = parseFloat(this.state.amount_to)
            amount_to = parseFloat(this.state.amount_from)
        }

        // let body = {
        //     "filters": {
        //         "BetStatuses": ["PLACED"],
        //         "current_user": this.state.accounts,
        //         "user_id": this.state.user_id,
        //         "amount_from": amount_from,
        //         "amount_to": amount_to,
        //         "competition_id": "",
        //         "sport_type": this.state.sportType,
        //         "event_id": this.state.eventName,
        //         "market_type": this.state.marketType,
        //         "market_id": this.state.marketName,
        //     },
        //     "last_id": "",
        //     "first_id": "",
        //     "action": "",
        //     "from": "",
        //     "to": "",
        //     "zone": new Date().getTimezoneOffset(),
        //     "page_no": 1,
        //     "count_records": "",
        //     "records_display": 100
        // }
        let body = {
            "filters":{
                "userId": this.state.user_id,
                "betStatus": ["PLACED"],
                "marketId": this.state.marketName,
                "eventId": this.state.eventName,
                "competitionId": "",
                "sportType": this.state.sportType,
                "marketType": this.state.marketType,
                "amountFrom": amount_from,
                "amountTo": amount_to,
            },
            "lastId": "",
            "firstId": "",
            "action": "",
            "from": "",
            "to": "",
            "countRecords": "",
            "pageNo": 1,
            "recordsPerPage": 100
        
        }
        body = this.clean(body);
        return body
    }

    async submitForm() {
        const self = this;
        let body = this.parseFilterBody()
        await currentBetsService.postApiOpenBets(body).then((res) => {
            if (res.isSuccess) {
                self.setState(
                    {
                        bets_data: [],
                        bets_search_data: [],
                        showData: true,
                        loader: true
                    }, () => {
                        this.setState({
                            bets_data: res.items,
                            bets_search_data: res.items,
                            loader: false
                        })
                    }
                );
            }
            else {
                this.setState({ bets_data: [], bets_search_data: [], showData: true, loader: false })
            }
        })
    }

    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }

    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }

    resetForm() {
        this.setState({ user_id: "", sportType: "ALL", eventName: "", marketType: "", marketName: "", mkts_name: [], evts_name: [], amount_from: "", amount_to: ""})
    }

    async onEventList() {
        this.setState({ eventLoader: true, evts_name: [], eventName: "", mkts_name: [], marketName: "", marketType: "" },
            () => {
                currentBetsService.getEventListByEventTypeName(this.state.sportType).then((res) => {
                    if (res.isSuccess) {
                        this.setState({ evts_name: res.items, eventLoader: false });
                    }
                    else {
                        // this.props.notify("No Events Found!", "error")
                        this.setState({ evts_name: [], eventLoader: false });
                    }
                })
            })
    }

    async onMarketList() {
        this.setState({ marketLoader: true, mkts_name: [], marketName: "" },
            () => {
                currentBetsService.getMarketListByEventName(this.state.eventName, this.state.marketType).then((res) => {
                    if (res.isSuccess) {
                        this.setState({ mkts_name: res.items, marketLoader: false });
                    }
                    else {
                        // this.props.notify("No Markets Found!", "error")
                        this.setState({ mkts_name: [], marketLoader: false });
                    }
                })
            })
    }

    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        if (name === "sportType" && value !== "ALL") {
            this.setState({ [name]: value }, () => {
                if (value !== "LOTUS" && value !== "SUPERNOVA" && value !== "DRC" && value !== "DIGITAIN") {
                    this.onEventList()
                } else {
                    this.setState({ evts_name: [], eventName: "", mkts_name: [], marketName: "", marketType: "" })
                }
            })
        }
        else if (name === "sportType") {
            this.setState({ [name]: value }, () => {
                this.onEventList()
            })
        }
        else if (name === "marketType" && value !== "" && !!this.state.eventName) {
            this.setState({ 
                [name]: value, 
                marketName: "" 
            },
                () => {
                    this.onMarketList()
                }
            )
        }
        else if (name === "eventName" && this.state.marketType !== "" && !!value) {
            this.setState({ [name]: value },
                () => {
                    this.onMarketList()
                }
            )
        }
        else {
            this.setState({ [name]: value })
        }
    }

    getEventMarketDictionary(event_dict) {
        this.setState({ event_dictionary: event_dict })
    }

    filterBets() {

        let bets_data = this.state.bets_data

        bets_data = bets_data.filter((bet) => {
            return this.state.deactivatMarkets.indexOf(bet.marketId) === -1
        })

        bets_data = bets_data.filter((bet) => {
            return this.state.deactivatOrders.indexOf(bet.orderId) === -1
        })

        if (this.state.sportType !== "" && this.state.sportType !== "ALL") {
            if (this.state.sportType !== "HorseRacing" && this.state.sportType !== "GreyhoundRacing"){
                bets_data = bets_data.filter((bet) => { return bet.eventTypeName === this.state.sportType })
            }
            else if (this.state.sportType === "HorseRacing"){
                bets_data = bets_data.filter((bet) => { return bet.eventTypeId === "7" })
            }
            else if (this.state.sportType === "GreyhoundRacing"){
                bets_data = bets_data.filter((bet) => { return bet.eventTypeId === "4339" })
            }
        }

        if (this.state.eventName !== "") {
            bets_data = bets_data.filter((bet) => { return bet.eventId === this.state.eventName })
        }

        if (this.state.marketType !== "" && this.state.marketType !== "LINE") {
            bets_data = bets_data.filter((bet) => { return bet.marketType === this.state.marketType })
        }
        else if (this.state.marketType !== "" && this.state.marketType === "LINE") {
            bets_data = bets_data.filter((bet) => { return bet.marketBettingType === "LINE" })
        }

        if (this.state.marketName !== "") {
            bets_data = bets_data.filter((bet) => { return bet.marketId === this.state.marketName })
        }

        if (this.state.amount_from !== "" && this.state.amount_from !== 0 && this.state.amount_from !== "0") {
            bets_data = bets_data.filter((bet) => { return bet.amount >= parseInt(this.state.amount_from) })
        }

        if (this.state.amount_to !== "" && this.state.amount_to !== 0 && this.state.amount_to !== "0") {
            bets_data = bets_data.filter((bet) => { return bet.amount <= parseInt(this.state.amount_to) })
        }

        if (this.state.user_id !== "") {
            bets_data = bets_data.filter((bet) => { return bet.username.includes(this.state.user_id) })
        }

        return bets_data
    }

    render() {

        let bets_data = this.filterBets()

        return (
            <div className="bethubs">
                <Header history = {this.props.history} getEventMarketDictionary={(event_dict) => this.getEventMarketDictionary(event_dict)} />
                <div className="wrapper">
                    <div className="container-fluid container-padding-0">
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="main-box">
                                    <h5 className="text-blue">Live Bets</h5>
                                    <div className="row mt-2">
                                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                            <div className="form-group font-12">
                                                <select title="Sport" className="form-control" name="sportType" value={this.state.sportType} onChange={(e) => { this.onChange(e) }}>
                                                    <option value="ALL">Select Sport</option>
                                                    <option value="Cricket">Cricket</option>
                                                    <option value="Football">Soccer</option>
                                                    <option value="Tennis">Tennis</option>
                                                    <option value="Kabaddi">Kabaddi</option>
                                                    <option value="Election">Election</option>
                                                    <option value="HorseRacing">Horse Racing</option>
                                                    <option value="GreyhoundRacing">Greyhound Racing</option>
                                                    <option value="Binary">Binary</option>
                                                    <option value="DIGITAIN">SportBook</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                            <div className="form-group font-12">
                                                <div className="input-group">
                                                    <select title="Event" className="form-control" name="eventName" value={this.state.eventName} onChange={(e) => { this.onChange(e) }} disabled={(this.state.sportType !== "LOTUS" && this.state.sportType !== "SUPERNOVA" && this.state.sportType !== "DRC" && this.state.sportType !== "DIGITAIN") ? false : true}>
                                                        <option value="">Select Event</option>
                                                        {this.state.evts_name.length > 0 ? this.state.evts_name.map((evt, i) => { return (<option key={evt.eventId + "_" + i} value={evt.eventId}>{evt.eventName}{this.state.sportType !== "Binary" && ` - ${new Date(evt.openDate).toLocaleDateString("hi-IN")}`}</option>) }) : ""}
                                                    </select>
                                                    {this.state.eventLoader &&
                                                        <span className="input-group-addon">
                                                            <i className="fa fa-refresh fa-spin"></i>
                                                        </span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                            <div className="form-group font-12">
                                                <select title="Market Type" className="form-control" name="marketType" value={this.state.marketType} onChange={(e) => { this.onChange(e) }} disabled={(this.state.sportType !== "LOTUS" && this.state.sportType !== "SUPERNOVA" && this.state.sportType !== "DRC" && this.state.sportType !== "DIGITAIN") ? false : true}>
                                                    <option value="">Select Market Type</option>
                                                    {(this.state.sportType === "Cricket" || this.state.sportType === "Football" || this.state.sportType === "Tennis") && <option value="ODDS">Odds</option>}
                                                    {(this.state.sportType === "Cricket" || this.state.sportType === "Football" || this.state.sportType === "Tennis" || this.state.sportType === "Election" || this.state.sportType === "Kabaddi") && <option value="BOOKMAKER">Bookmaker</option>}
                                                    {(this.state.sportType === "Cricket" || this.state.sportType === "Election" || this.state.sportType === "Kabaddi") && <option value="LINE">Fancy</option>}
                                                    {/* {(this.state.sportType === "Cricket" || this.state.sportType === "Football" || this.state.sportType === "Tennis") && <option value="MINI_BOOKMAKER">Mini Bookmaker</option>} */}
                                                    {/* {this.state.sportType === "Football" && <option value="OVER_UNDER_05">Over/Under 0.5 Goals</option>}
                                                    {this.state.sportType === "Football" && <option value="OVER_UNDER_25">Over/Under 2.5 Goals</option>}
                                                    {this.state.sportType === "Football" && <option value="OVER_UNDER_15">Over/Under 1.5 Goals</option>}
                                                    {this.state.sportType === "Football" && <option value="OVER_UNDER_35">Over/Under 3.5 Goals</option>}
                                                    {(this.state.sportType === "HorseRacing" || this.state.sportType === "GreyhoundRacing" )&& <option value="WIN">Win</option>}
                                                    {this.state.sportType === "Binary" && <option value="DAILY">Daily</option>}
                                                    {this.state.sportType === "Binary" && <option value="1_HOUR">1 Hour</option>}
                                                    {this.state.sportType === "Binary" && <option value="2_HOUR">2 Hour</option>} */}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                            <div className="form-group font-12">
                                                <div className="input-group">
                                                    <select title="Market" className="form-control" name="marketName" value={this.state.marketName} onChange={(e) => { this.onChange(e) }} disabled={(this.state.marketType !== "" && !!this.state.eventName && this.state.sportType !== "LOTUS" && this.state.sportType !== "SUPERNOVA" && this.state.sportType !== "DRC") ? false : true}>
                                                        <option value="">Select Market</option>
                                                        {this.state.mkts_name.length > 0 ? this.state.mkts_name.map((mkt, i) => <option key={mkt.marketId + "_" + i} value={mkt.marketId}>{mkt.marketName}</option>) : ""}
                                                    </select>
                                                    {this.state.marketLoader &&
                                                        <span className="input-group-addon">
                                                            <i className="fa fa-refresh fa-spin"></i>
                                                        </span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
                                            <div className="form-group font-12">
                                                <input className="form-control" title="Amount From" value={this.state.amount_from} type="number" onChange={(e) => this.onChange(e)} id="from_amount" name="amount_from" placeholder="Amount From" />
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
                                            <div className="form-group font-12">
                                                <input className="form-control" title="Amount To" value={this.state.amount_to} type="number" onChange={(e) => this.onChange(e)} id="to_amount" name="amount_to" placeholder="Amount To" />
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
                                            <div className="form-group font-12 autocomplete-wrapper">
                                                <input className="form-control" title="Search by client" value={this.state.user_id} type="text" onChange={(e) => { this.onChange(e) }} id="user_id" name="user_id" placeholder="Search by client" />
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
                                            <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                                <button className="btn btn-success" onClick={(e) => { this.setState({ isStop: false }) }} disabled={this.state.isStop ? false : true}>Start</button>
                                                <button className="btn btn-danger ml-1" onClick={(e) => { this.setState({ isStop: true }) }} disabled={!this.state.isStop ? false : true}>Stop</button>
                                                <button className="btn btn-blue ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                            </div>
                                        </div>
                                    </div>
                                    {!this.state.showData && !!this.state.loader ? <div className="ml-2 mt-2">Loading......</div> : null}
                                    {!!this.state.showData && <div>
                                        <div className="row">
                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                <div className="table-responsive">
                                                    <table id="example" className="table font-12 table-bordered table-sm addpadding mt-2 whitespace">
                                                        <thead>
                                                            <tr>
                                                                <th className="pthead">Time</th>
                                                                <th className="pthead">User</th>
                                                                {/* <th className="pthead">Distributor</th> */}
                                                                <th className="pthead">Competition</th>
                                                                <th className="pthead">Event</th>
                                                                <th className="pthead">Market</th>
                                                                <th className="pthead rw-120">Runner</th>
                                                                <th className="pthead rw-40">Side</th>
                                                                <th className="text-right pthead rw-40">Line</th>
                                                                <th className="text-right pthead rw-45">Rate</th>
                                                                <th className="text-right pthead rw-80">Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {!!this.state.loader ?
                                                                <tr>
                                                                    <td colSpan={15} align="center">
                                                                        Loading......
                                                                    </td>
                                                                </tr> :
                                                                bets_data.length > 0 ? bets_data.map((order, i) => {
                                                                    let price = order.price
                                                                    let competitionName = order.competitionName ? (order.eventTypeId === '300' ? dateUtil.getBinaryCompetitionDisplayName(order.competitionName) : order.competitionName) : "-"
                                                                    if(order.eventTypeId === '300'){
                                                                                order.market_time =  dateUtil.getBinaryMarketDisplayName(order.marketName)
                                                                            }
                                                                    return (
                                                                        <tr key={i} bgcolor={order.side === 0 ? "#72BBEF" : order.side === 1 ? "#FAA9BA" : ""}>
                                                                            <td>{order.createdAt ? moment(order.createdAt.indexOf('T') > -1 ? order.createdAt : (order.createdAt + '+00:00')).format('D/M/YYYY hh:mm:ss A') : "-"}</td>
                                                                            <td>{order.username ? order.username : "-"}</td>
                                                                            {/* <td>{order.parents ? userUtil.getAppropriateParent(order.parents, this.state.accounts): "-"}</td> */}
                                                                            <td className="dtwidth" title={competitionName} >{competitionName}</td>
                                                                            <td title={!!order.eventName ? order.eventName : "-"}>{!!order.eventName ? order.eventName : "-"}</td>
                                                                            <td className="" title={!!order.marketName ? order.marketName : "-"}>{order.eventTypeId === '300' && !!order.market_time && order.market_time.length > 0 ? 
                                                                            <>
                                                                                {order.market_time[0] }
                                                                                <span className=''> [<b>{(order.market_time.length > 0 ? order.market_time[1] : "")}</b>]</span>
                                                                            </>
                                                                            
                                                                            : !!order.marketName ? order.marketName : "-"}</td>
                                                                            <td className="idwidthrunner">{!!order.runnerName ? order.runnerName : "-"}</td>
                                                                            <td>{order.side === 0 ? "Back" : order.side === 1 ? "Lay" : order.side === -1 ? "Unknown" : "-"}</td>
                                                                            <td className="text-right fbold">{order.marketBettingType === "LINE" && !!order.runnerId ? order.runnerId : "-"}</td>
                                                                            <td className="text-right fbold">{!!price ? price : "0.00"} </td>
                                                                            <td className="text-right fbold">{!!order.amount ? <Currency key={"unsettle_amt_" + 1} className="fbold" amount={order.amount} showColor={false} /> : "-"}</td>
                                                                        </tr>
                                                                    );
                                                                }) : <tr>
                                                                    <td colSpan={25} align="center">
                                                                        No Data Found.
                                                                    </td>
                                                                </tr>}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(LiveBets);